module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ActivityProductListView.js"));
	}, "ActivityProductListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ActivityProductListView!./src/pages/Shop/ShoppingCart/ActivityProductList/ActivityProductListView.js
// module id = 1359
// module chunks = 418